module.exports = __webpack_public_path__ + "img/racetrack-greyville-poly.f8dae323.svg";